import RelatorioHTML from '@/utils/RelatorioHTML'
import moment from 'moment'

export async function imprimirDocumentoCarregamento(pedidoId, http) {
  try {
    const response = await http.get(`/api/protected/terminal/expedicao/volumes/getDadosCarregamento/${pedidoId}`)
    const { empresa, venda, itens } = response.data

    const html = `
      <!doctype html>
      <html>
      <head>
        <meta charset="utf-8">
        <title>Embarque_${venda.SEQUENCIA}</title>
        <style>
          body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; margin: 0; padding: 10mm; color: #1e293b; }
          .loading-doc { width: 100%; }
          .header-table { width: 100%; border-bottom: 2px solid #334155; margin-bottom: 20px; padding-bottom: 10px; }
          .company-name { font-size: 18px; font-weight: bold; color: #0f172a; text-transform: uppercase; }
          .company-info { font-size: 11px; color: #64748b; }
          .doc-title { font-size: 20px; font-weight: 800; text-align: right; color: #4f46e5; }
          
          .summary-box { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 20px; margin-bottom: 20px; background: #f8fafc; padding: 15px; border-radius: 8px; border: 1px solid #e2e8f0; }
          .summary-item label { display: block; font-size: 9px; text-transform: uppercase; color: #94a3b8; font-weight: 700; margin-bottom: 2px; }
          .summary-item span { font-size: 13px; font-weight: 600; color: #1e293b; }
          
          .client-info { margin-bottom: 20px; padding: 10px; border-left: 4px solid #4f46e5; background: #fff; }
          .client-info h3 { margin: 0 0 5px 0; font-size: 15px; }
          .client-info p { margin: 0; font-size: 11px; color: #475569; }

          .items-table { width: 100%; border-collapse: collapse; margin-bottom: 30px; }
          .items-table th { background: #334155; color: #fff; text-align: left; padding: 10px; font-size: 10px; text-transform: uppercase; letter-spacing: 0.05em; }
          .items-table td { padding: 10px; border-bottom: 1px solid #e2e8f0; font-size: 12px; }
          .items-table tr:nth-child(even) { background: #fcfdfe; }
          .text-right { text-align: right; }
          .font-bold { font-weight: bold; }
          
          .totals-section { margin-left: auto; width: 300px; }
          .total-row { display: flex; justify-content: space-between; padding: 5px 0; border-bottom: 1px dashed #cbd5e1; }
          .total-row.grand-total { border-bottom: none; margin-top: 5px; padding-top: 10px; border-top: 2px solid #0f172a; font-size: 16px; font-weight: 800; }
          
          .signature-section { margin-top: 60px; display: grid; grid-template-columns: 1fr 1fr; gap: 40px; }
          .signature-line { border-top: 1px solid #334155; padding-top: 10px; text-align: center; font-size: 11px; color: #64748b; }
          
          @media print {
            .no-print { display: none; }
            body { margin: 0; padding: 10mm; }
            .summary-box { background: #f8fafc !important; -webkit-print-color-adjust: exact; }
            .items-table th { background: #334155 !important; -webkit-print-color-adjust: exact; }
          }
        </style>
      </head>
      <body>
        <div class="loading-doc">
          <table class="header-table">
            <tr>
              <td>
                <div class="company-name">${empresa.FANTASIA || empresa.RAZAO}</div>
                <div class="company-info">
                  ${empresa.ENDERECO} - ${empresa.CIDADE}/${empresa.UF}<br>
                  CNPJ: ${empresa.CNPJ} | Fone: ${empresa.TX_TELEFONE}
                </div>
              </td>
              <td class="doc-title">
                COMPROVANTE DE EMBARQUE<br>
                <span style="font-size: 14px; color: #64748b;">PEDIDO #${venda.SEQUENCIA}</span>
              </td>
            </tr>
          </table>

          <div class="summary-box">
            <div class="summary-item">
              <label>Nº Pedido / Fatura</label>
              <span>${venda.N_VENDA || venda.SEQUENCIA}</span>
            </div>
            <div class="summary-item">
              <label>Data Saída</label>
              <span>${moment(venda.DT_SAIDA).format('DD/MM/YYYY')}</span>
            </div>
            <div class="summary-item">
              <label>Data Embarque</label>
              <span>${moment(venda.DT_EXPEDICAO).format('DD/MM/YYYY HH:mm')}</span>
            </div>
            <div class="summary-item">
              <label>Motorista</label>
              <span>${venda.NOME_MOTORISTA || 'NÃO INFORMADO'}</span>
            </div>
            <div class="summary-item">
              <label>Placa do Veículo</label>
              <span>${venda.PLACA || '—'}</span>
            </div>
            <div class="summary-item">
              <label>Conferente / Usuário</label>
              <span>${venda.USUARIO_EXPEDICAO || 'SISTEMA'}</span>
            </div>
          </div>

          <div class="client-info">
            <label style="margin-bottom: 5px; display: block; font-size: 10px; font-weight: bold; color: #4f46e5;">DESTINATÁRIO</label>
            <h3>${venda.COD_CLI} - ${venda.NOME_CLIENTE}</h3>
            <p>
              ${venda.ENDERECO_CLIENTE || ''}, ${venda.BAIRRO_CLIENTE || ''}<br>
              ${venda.CIDADE_CLIENTE || ''} - ${venda.UF_CLIENTE || ''} | CNPJ/CPF: ${venda.CNPJ_CLIENTE || ''}
            </p>
          </div>

          <table class="items-table">
            <thead>
              <tr>
                <th width="40">Item</th>
                <th width="60">Cód</th>
                <th>Descrição do Produto</th>
                <th width="50" class="text-right">Un</th>
                <th width="80" class="text-right">Pedida</th>
                <th width="80" class="text-right">Embarcada</th>
              </tr>
            </thead>
            <tbody>
              ${itens.map((i, index) => `
                <tr>
                  <td>${i.ITEM || (index + 1)}</td>
                  <td>${i.COD_PRO}</td>
                  <td class="font-bold">${i.NOME_PRODUTO}</td>
                  <td class="text-right">${i.UNIDADE}</td>
                  <td class="text-right">${Number(i.QUANT_PEDIDO).toLocaleString('pt-BR', { minimumFractionDigits: 3 })}</td>
                  <td class="text-right font-bold">${Number(i.QUANT_EMBARCADA).toLocaleString('pt-BR', { minimumFractionDigits: 3 })}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>

          <div style="display: flex; gap: 40px">
            <div style="flex: 1">
              <label style="font-size: 10px; font-weight: bold; color: #4f46e5; margin-bottom: 5px; display: block;">OBSERVAÇÕES DO PEDIDO</label>
              <div style="font-size: 11px; color: #475569; min-height: 50px; border: 1px solid #e2e8f0; padding: 10px; border-radius: 6px;">
                ${venda.OBSERVACOES || 'Sem observações.'}
                ${venda.OBS_EXPEDICAO ? `<br><strong>Expedição:</strong> ${venda.OBS_EXPEDICAO}` : ''}
              </div>
            </div>
            <div class="totals-section">
              <div class="total-row">
                <label>VOLUMES:</label>
                <span>${itens.reduce((s, i) => s + Number(i.QUANT_PEDIDO), 0).toLocaleString('pt-BR', { minimumFractionDigits: 3 })}</span>
              </div>
              <div class="total-row grand-total">
                <label>TOTAL EMBARCADO:</label>
                <span>${itens.reduce((s, i) => s + Number(i.QUANT_EMBARCADA), 0).toLocaleString('pt-BR', { minimumFractionDigits: 3 })}</span>
              </div>
            </div>
          </div>

          <div class="signature-section">
            <div class="signature-line">
              Responsável pela Conferência<br>
              <strong>${venda.USUARIO_EXPEDICAO || '__________________________'}</strong>
            </div>
            <div class="signature-line">
              Motorista / Recebedor<br>
              <strong>${venda.NOME_MOTORISTA || '__________________________'}</strong>
            </div>
          </div>
        </div>
      </body>
      </html>
    `

    RelatorioHTML.imprimir(html, `Embarque_${venda.SEQUENCIA}`, 'A4', 'portrait')
  } catch (err) {
    console.error('Erro ao gerar relatório de carregamento', err)
    throw err
  }
}



// WEBPACK FOOTER //
// ./src/views/expedicao/volumes/ExpedicaoVolumesPrint.js